import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import Log from "../../icons/Logout.svg";
import Settings from "../../icons/settings.svg";
import InboxIcon from "../../icons/inboxIcon.svg";
import { ReactComponent as OverviewIcon } from "../../icons/overviewIcon.svg";
import { ConditionalRenderer } from "components/conditonal-renderer";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { ModalCloseIcon } from "icons";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { ConfirmationPopUp } from "pages/cases-detail/components/modals";
import { admin } from "authRoute/constants";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import { InboxOutlined } from "@ant-design/icons";

export function Logout({ setVisible }) {
  const { translator } = useLanguageTranslator();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { saveUserData, user } = useCurrentUserContext();
  const [getData] = UseLazyApiCallV2({
    method: "POST",
    url: "/logout_user",
  });
  const [getLoginUrl, { isLoading: getLoginUrlLoading }] = UseLazyApiCallV2({
    method: "POST",
    url: "/prod/login-url",
  });
  const logoutHandler = async () => {
    Cookies.remove("sessionToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userEmail");
    Cookies.remove(`${getCurrentEnviornment()}_sessionToken`);
    localStorage.removeItem(`${getCurrentEnviornment()}_userId`);

    if (
      !localStorage.getItem(`${ENVIORNMENTS.LIVE}_userId`) &&
      !localStorage.getItem(`${ENVIORNMENTS.SANDBOX}_userId`)
    ) {
      await getData({
        params: {
          secret_id: user?.secret_id,
        },
      });
      saveUserData(null);
      setIsModalOpen(false);
      navigate("/");
    } else {
      sessionStorage.setItem(
        ENVIORNMENTS.ENVIORNMENT,
        `${
          getCurrentEnviornment() === ENVIORNMENTS.LIVE
            ? ENVIORNMENTS.SANDBOX
            : ENVIORNMENTS.LIVE
        }`,
      );
      navigate("/cases");
      window.location.reload();
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSettings = () => {
    setVisible(false);
    navigate("/settings");
  };

  return (
    <>
      {/* <Modal
        className={styles.logoutModal}
        closeIcon={<ModalCloseIcon />}
        title=""
        open={isModalOpen}
        cancelText="No"
        centered={true}
        okText="Yes"
        width={792}
        footer={null}
        onCancel={handleCancel}
      >
        <h1>Confirmation</h1>
        <p>Are you sure you want to logout?</p>
        <div className={styles["modal-buttons"]}>
          <Button
            className={styles.modalYesButton}
            type="primary"
            onClick={logoutHandler}
          >
            Yes
          </Button>
          <Button className={styles.modalNoButton} onClick={handleCancel}>
            No
          </Button>
        </div>
      </Modal> */}
      {/* <button
        onClick={handleClickInbox}
        className={styles["logout-back"]}
        style={{ marginBottom: "10px" }}
      >
        <span>
          <img
            src={InboxIcon}
            style={{ marginRight: "5px" }}
            className="log"
            alt="log"
          />
          {translator("inboxText")}
        </span>
      </button> */}
      <ConditionalRenderer condition={admin.includes(user?.role)}>
        <button
          onClick={handleSettings}
          className={styles["logout-back"]}
          style={{ marginBottom: "10px" }}
        >
          <span>
            <img
              src={Settings}
              style={{ marginRight: "5px" }}
              className="log"
              alt="log"
            />
            {translator("settingsText")}
          </span>
        </button>
      </ConditionalRenderer>

      {/* <button
        onClick={() => {
          setVisible(false);
          navigate("/analytics");
        }}
        className={styles["logout-back"]}
        style={{ marginBottom: "10px" }}
      >
        <span>
          <OverviewIcon style={{ marginRight: "5px" }} />
          Analytics
        </span>
      </button> */}

      <ConfirmationPopUp
        Icon={null}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        description={translator("confirmationFoLogout")}
        title={translator("logout")}
        onConfirm={logoutHandler}
      />

      <button onClick={showModal} className={styles["logout-back"]}>
        <span>
          <img
            height={15}
            width={19}
            src={Log}
            style={{ marginRight: "5px" }}
            className="log"
            alt="log"
          />
          {translator("logoutText")}
        </span>
      </button>
    </>
  );
}

export default Logout;
